import React, { useReducer, useEffect, useState, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  RequiredRule,
  HeaderFilter,
  Button,
  Scrolling,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import * as actions from "../../actions/settings";
import settingsReducer from "../../reducers/settings";
import TagBox from "devextreme-react/tag-box";
import { CONFIG } from "../settings/config";
import ColorBox from "devextreme-react/color-box";
import NEXUS_CONST from "../../common/constants";
import AsyncCallHandler from "../../common/AsyncCallHandler";

import {
  set,
  get,
  setGridUserPrefs,
  setGridWidthPrefs,
  applyUserPref,
  saveUserPref,
} from "../../common/utils";

const initialState = {
  smessReasonCodeDataAdmin: [],
  tiersData: null,
  userPrefSettings: null,
};
export default () => {
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  let { smessReasonCodeDataAdmin, tiersData, userPrefSettings } = state;
  const [pData, setPData] = useState([]);
  const smessGrid = useRef(null);

  useEffect(() => {
    actions.fetchTiers(dispatch, "");
    actions.fetchSmessReasonCodeListforAdmin(dispatch);
  }, []);

  const widgetId = "smessReasonCode";
  const GRID_COLS = JSON.stringify([
    "assessmentID",
    "reasonID",
    "assessment",
    "reason",
  ]);
  const loggedinUser = get("hid");
  const siteId = "AdminConsole";

  useEffect(() => {
    actions.fetchUserPref(
      dispatch,
      `=0&SiteUID=${siteId}&widgetID=${widgetId}`
    );
    return () => {
      actions.updateUserPref(
        dispatch,
        saveUserPref({
          widgetId,
          siteId: "AdminConsole",
          tierId: 0,
          moduleName: widgetId,
          loggedinUser,
          prefSess: "userPrefSettings",
          GRID_COLS,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (userPrefSettings) set("userPrefSettings", userPrefSettings);
    if (
      smessGrid &&
      smessGrid.current &&
      smessGrid.current.instance !== null &&
      userPrefSettings !== null
    ) {
      applyUserPref(smessGrid, userPrefSettings);
    }
  }, [userPrefSettings, smessReasonCodeDataAdmin, tiersData]);

  useEffect(() => {
    if (smessReasonCodeDataAdmin.length) {
      setPData(smessReasonCodeDataAdmin);
    }
  }, [smessReasonCodeDataAdmin]);

  const onRowInserted = (data) => {
    let { assessment, reason } = data.data;
    let assessmentId = 0;
    switch (assessment) {
      case "Safety":
        assessmentId = 1;
        break;
      case "Methods":
        assessmentId = 2;
        break;
      case "Equipment":
        assessmentId = 3;
        break;
      case "Supplies":
        assessmentId = 4;
        break;
      default:
        assessmentId = 5;
    }
    let input = {
      assessmentID: assessmentId,
      reasonID: 0,
      assessment: assessment,
      reason: reason,
    };
    actions.updateSMESSReasonCodeforadminconsole(dispatch, input);
  };
  const onRowUpdated = (data) => {
    let { assessment, reasonID, reason } = data.data;
    let assessmentId = 0;
    switch (assessment) {
      case "Safety":
        assessmentId = 1;
        break;
      case "Methods":
        assessmentId = 2;
        break;
      case "Equipment":
        assessmentId = 3;
        break;
      case "Supplies":
        assessmentId = 4;
        break;
      default:
        assessmentId = 5;
    }
    let input = {
      assessmentID: assessmentId,
      reasonID: reasonID,
      assessment: assessment,
      reason: reason,
    };
    actions.updateSMESSReasonCodeforadminconsole(dispatch, input);
  };

  const onRowRemoved = (data) => {
    actions.deleteSMESSReasonCodeforAdminConsole(dispatch, data.data.reasonID);
  };

  const handlers = {
    onRowInserted: onRowInserted,
    onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
  };

  return (
    <>
      {tiersData && (
        <DataGrid
          dataSource={pData}
          allowColumnReordering={true}
          showBorders={true}
          {...CONFIG.SMESS_REASON_CODE_GRID_ADMINCONSOLE}
          {...handlers}
          ref={smessGrid}
          onContentReady={(e) => setGridUserPrefs(e, widgetId)}
          onColumnsChanging={(e) => setGridWidthPrefs(e, widgetId)}
        >
          <Paging defaultPageSize={5} />
          <Pager
            visible={true}
            allowedPageSizes={[5, 10, 20, 50]}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />
          <Column
            dataField="assessmentID"
            caption="Id"
            dataType="number"
            visible={false}
            allowEditing={false}
          ></Column>
          <Column
            dataField="reasonID"
            caption="Reason Id"
            dataType="number"
            visible={false}
            allowEditing={false}
          ></Column>

          <Column dataField="assessment" caption="Assessment" visible={true}>
            <RequiredRule />
            <Lookup
              dataSource={NEXUS_CONST.SMESSReasonList}
              valueExpr="key"
              displayExpr="value"
            />
          </Column>
          <Column dataField="reason" caption="Reason Code" visible={true}>
            <RequiredRule />
          </Column>
        </DataGrid>
      )}
    </>
  );
};
